(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.new-product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
            var prevButton = productRecommendationsSection.querySelector('.slick-nav-prev');
            var nextButton = productRecommendationsSection.querySelector('.slick-nav-next');

            $('.new-product-recommendations-slider .glide').each(function () {
              const $glide = $(this);
              const sectionId = $glide.data('section-id');
              const $controls = $(`[data-section-controls="${sectionId}"]`);

              if ($controls.length) {
                const glideInstance = new Glide($glide[0], {
                  type: 'carousel',
                  perView: 4,
                  gap: 27,
                  breakpoints: {
                    768: {
                      perView: 1,
                      gap: 10,
                      peek: {
                        before: 0,
                        after: 70,
                      },
                    },
                    1200: {
                      perView: 2,
                    }
                  }
                });

                glideInstance.mount();

                window.dispatchEvent(new Event('resize'));

                $controls.find('.glide__arrow--left').on('click', function () {
                  glideInstance.go('<');
                });

                $controls.find('.glide__arrow--right').on('click', function () {
                  glideInstance.go('>');
                });
              }
            });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    const productRecommendationsSection = document.querySelector('.new-product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

    observer.observe(productRecommendationsSection);

    $('.new-product-recommendations-slider .glide').each(function () {
      const $glide = $(this);
      const sectionId = $glide.data('section-id');
      const $controls = $(`[data-section-controls="${sectionId}"]`);

      if ($controls.length) {
        const glideInstance = new Glide($glide[0], {
          type: 'carousel',
          perView: 4,
          gap: 27,
          breakpoints: {
            768: {
              perView: 1,
              gap: 10,
              peek: {
                before: 0,
                after: 70,
              },
            },
            1200: {
              perView: 2,
            }
          }
        });

        glideInstance.mount();

        window.dispatchEvent(new Event('resize'));

        $controls.find('.glide__arrow--left').on('click', function () {
          glideInstance.go('<');
        });

        $controls.find('.glide__arrow--right').on('click', function () {
          glideInstance.go('>');
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
